import type { FlatItem } from '@martech-solution/utils/types';
import { http } from '@martech-solution/utils/utils';

const controller = 'master-data/salary-grades';

export const getSalaryGradesDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
